import { ClaimDefaultChronicleTypeSchema } from '@eigtech/summarizer-types'
import { zodEnumWithUserFriendlyError } from '@eigtech/ui-shared-forms-lib'
import { z } from 'zod'
import { getClaimTimelineEventLabel } from './timelineLabels'

export const AvailableEventWithMaxFutureDateSchema = zodEnumWithUserFriendlyError(
  [ClaimDefaultChronicleTypeSchema.enum.inspectionScheduled],
  { optionFormatter: getClaimTimelineEventLabel }
)

export const AvailableEventWithMaxTodayDateSchema = zodEnumWithUserFriendlyError(
  [
    ClaimDefaultChronicleTypeSchema.enum.initialCustomerContactSuccess,
    ClaimDefaultChronicleTypeSchema.enum.customerContactedLvm,
    ClaimDefaultChronicleTypeSchema.enum.customerContactedEmail,
    ClaimDefaultChronicleTypeSchema.enum.customerNoContact,
    ClaimDefaultChronicleTypeSchema.enum.invalidContactInformation,
    ClaimDefaultChronicleTypeSchema.enum.inspectionCompleted,
    ClaimDefaultChronicleTypeSchema.enum.jobCompleted,
    ClaimDefaultChronicleTypeSchema.enum.jobNotSold,
    ClaimDefaultChronicleTypeSchema.enum.jobSold,
    ClaimDefaultChronicleTypeSchema.enum.jobStarted,
    ClaimDefaultChronicleTypeSchema.enum.qaApproved,
    ClaimDefaultChronicleTypeSchema.enum.qaApprovedPreliminaryReport,
    ClaimDefaultChronicleTypeSchema.enum.qaApprovedSupplementReport,
    ClaimDefaultChronicleTypeSchema.enum.qaRejected,
    ClaimDefaultChronicleTypeSchema.enum.reInspectionRequested,
  ],
  { optionFormatter: getClaimTimelineEventLabel }
)

export const AvailableEventSchema = z.enum([
  ...AvailableEventWithMaxTodayDateSchema.options,
  ...AvailableEventWithMaxFutureDateSchema.options,
])

export const eventsWithFutureDate: string[] = AvailableEventWithMaxFutureDateSchema.options

export type AvailableEvent = z.infer<typeof AvailableEventSchema>
export type AvailableEventWithMaxFutureDate = z.infer<typeof AvailableEventWithMaxFutureDateSchema>
